module.exports = __webpack_public_path__ + "img/empty-cart.fcee67f1.png";